import { PageWrapper } from '@repo/ui';
import { ReactElement, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  Button,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
} from 'reactstrap';

import { GroupSettingsTabPanes } from '../components/group-settings-tab-panes';
import { useGroupSettings } from '../hooks/useGroupSettings';
import { GroupSettingsTabIds } from '../models/group-settings-tab-ids';

interface ITab {
  id: GroupSettingsTabIds;
  label: string;
  icon: ReactElement;
}

export const GroupSettings = () => {
  // Hooks
  const {
    activeTab,
    groupId,
    selectedGroupData,
    navigate,
    getLegends,
    setActiveTab,
    requestGetGroupById,
  } = useGroupSettings();

  // Constants
  const tabs: ITab[] = [
    {
      id: 'coordinators',
      label: getLegends('COORDENADOR', true),
      icon: <i className="ri-user-line"></i>,
    },
    {
      id: 'teachers',
      label: getLegends('PROFESSOR', true),
      icon: <i className="ri-book-open-line"></i>,
    },
    {
      id: 'preceptors',
      label: getLegends('PRECEPTOR', true),
      icon: <i className="ri-eye-line"></i>,
    },
    {
      id: 'students',
      label: getLegends('ESTUDANTE', true),
      icon: <i className="ri-group-line"></i>,
    },
    {
      id: 'internship-locations',
      label: getLegends('LOCAL_ESTAGIO', true),
      icon: <i className="ri-map-pin-line"></i>,
    },
  ];

  useEffect(() => {
    requestGetGroupById({ groupId });
  }, [groupId]);

  return (
    <PageWrapper title={`Configurar ${getLegends('GRUPO')}`}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Configurar {getLegends('GRUPO')}</h4>
        <Button
          color="link"
          className="text-decoration-underline"
          onClick={() => navigate('/grupos')}
        >
          Voltar
        </Button>
      </div>
      <Card>
        <CardBody className="d-flex">
          {selectedGroupData ? (
            <>
              <h5 className="fw-semibold">{selectedGroupData?.name}&nbsp;</h5>
              <p className="mb-0 text-primary">/ {selectedGroupData?.code}</p>
            </>
          ) : (
            <div className="d-flex align-items-center">
              <Skeleton
                baseColor="#e8e8e8c5"
                highlightColor="#bababa96"
                style={{ height: '18px', width: '200px' }}
              />
              <span className="mt-1">&nbsp;/&nbsp;</span>
              <Skeleton
                baseColor="#e8e8e8c5"
                highlightColor="#bababa96"
                style={{ height: '16px', width: '100px' }}
              />
            </div>
          )}
        </CardBody>
        <Nav tabs>
          {tabs.map((tab, idx) => (
            <NavItem key={idx}>
              <NavLink
                className={`${activeTab === tab.id ? 'active' : ''}`}
                style={{ cursor: 'pointer' }}
                onClick={() => setActiveTab(tab.id)}
              >
                <div className="d-flex justify-content-center align-items-center gap-1">
                  {tab.icon}
                  {tab.label}
                </div>
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        <TabContent activeTab={activeTab}>
          <GroupSettingsTabPanes groupId={groupId} />
        </TabContent>
      </Card>
    </PageWrapper>
  );
};
